import React from 'react';
import Logo from './Logo';
import { useIsMobile } from '../../hooks/useIsMobile';
import { SHELL_WHITE, alpha } from '../../theme/colors';
import Button from '../shared/Button';

// Split into two distinct CTAs (per the finalized Paper nav, AKU-0
// desktop / A80-0 mobile) rather than one combined "Sign up / Log in"
// pill — matches app.vesna.health now having separate Log In / Sign Up
// screens instead of one dual-purpose form.
const Nav = ({ onSignIn, onGetStarted }) => {
  const isMobile = useIsMobile();

  const textShadow = isMobile ? 'none' : '0 1px 4px rgba(0,0,0,0.3)';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: isMobile ? '20px 20px 0 20px' : '0 0 10px 0',
      }}
    >
      <Logo size={isMobile ? 18 : 22} textSize={isMobile ? 18 : 22} color={SHELL_WHITE} />
      {/* Paper's mobile spec (A80-0) gives "Log in" zero horizontal padding,
          relying on nothing else for spacing before the "Sign up" pill —
          reads as smushed together in practice. A flat 8px gap fixes it on
          both breakpoints (desktop already had its own padding-based
          spacing, so this just adds a little more there — harmless). */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Button
          variant="text"
          onClick={onSignIn}
          style={{
            padding: isMobile ? '8px 0' : '10px 20px',
            fontFamily: 'DM Sans',
            fontWeight: 500,
            fontSize: isMobile ? 12 : 13,
            color: SHELL_WHITE,
            textShadow,
          }}
        >
          Log in
        </Button>
        <Button
          variant="ghost"
          tone="white"
          onClick={onGetStarted}
          style={{
            padding: isMobile ? '8px 16px' : '10px 20px',
            borderRadius: 999,
            background: isMobile ? 'transparent' : alpha('white', 0.08),
            fontFamily: 'DM Sans',
            fontWeight: 500,
            fontSize: isMobile ? 12 : 13,
            textShadow,
          }}
        >
          Sign up
        </Button>
      </div>
    </div>
  );
};

export default Nav;
